class ProductCustomization {
  constructor() {
    this.keyboardIcon = document.querySelector(".product-block--input_inner-keyboard");
    this.popover = document.querySelector(".custom-keyboard-popover");
    this.inputPlaceHolder = document.querySelector("#product-customization_color");
    this.customizationBlock = document.querySelector(".product-block--field-customization");
    this.inputText = document.getElementById("product-customization_text");
    this.inputCounting = document.getElementById("product-block--input-counting");
    this.selectZodiac = document.getElementById("product-customization_select");
    this.maxLength = parseInt(this.inputText.getAttribute("maxlength"), 10);
    this.slider = document.querySelector(".product__main-photos .flickity-slider");
    this.canvas = document.createElement("canvas");
    this.ctx = this.canvas.getContext("2d");
    this.fontSize = parseInt(this.customizationBlock.dataset.fontsize) || 40;
    this.specialChars = ['♡', '#', '★', '’', '/', '-', '.', '|'];
    this.matchedHexColor = this.customizationBlock.dataset.defaultcolor || "#ffffff";
    this.canvasAttached = false;
    this.previewWrapper = document.createElement("div");
    this.previewWrapper.className = "customization-text-preview";
    this.previewWrapper.appendChild(this.canvas);
    this.colorsData = this.buildColorsData();
    this.setupCollapse();
    this.drawTextWithZodiac();
    this.init();
  }

  buildColorsData() {
    return {
      "colors": [
        
        
        
        
      ]
    };
  }

  countCharacters(string) {
    if (window.Intl && Intl.Segmenter) {
      const segmenter = new Intl.Segmenter("en", { granularity: "grapheme" });
      return [...segmenter.segment(string)].length;
    }
    return [...string].length;
  }

  init() {
    this.setupKeyboard();
    this.attachInputListeners();
    this.handleVariantClick();
    this.setupVariantImageListeners();
    this.updateInputCounting();

    if (window.defaultCustomizationImageIndex !== undefined) {
      this.attachCanvasToSlide(window.defaultCustomizationImageIndex);
    }
  }

  setupKeyboard() {
    this.specialChars.forEach(char => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.textContent = char;
      btn.addEventListener("click", () => this.insertSpecialChar(char));
      this.popover.appendChild(btn);
    });

    this.keyboardIcon.addEventListener("click", (e) => {
      e.stopPropagation();
      this.popover.style.display = this.popover.style.display === "none" ? "flex" : "none";
    });

    document.addEventListener("click", (e) => {
      if (!this.popover.contains(e.target) && !this.keyboardIcon.contains(e.target)) {
        this.popover.style.display = "none";
      }
    });
  }

  insertSpecialChar(char) {
    const start = this.inputText.selectionStart;
    const end = this.inputText.selectionEnd;
    const value = this.inputText.value;
    const zodiac = this.selectZodiac.value || "";
    const newValue = value.substring(0, start) + char + value.substring(end);
    const totalLength = this.countCharacters(newValue + zodiac);

    if (totalLength <= this.maxLength) {
      this.inputText.value = newValue;
      this.inputText.focus();
      this.inputText.setSelectionRange(start + 1, start + 1);
      this.inputText.dispatchEvent(new Event('input'));
    } else {
      this.triggerPulse();
    }
  }

  attachInputListeners() {
    this.inputText.addEventListener("input", () => this.updateInputCounting());
    this.inputText.addEventListener("keydown", (e) => {
      const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
      const zodiac = this.selectZodiac.value || "";
      const inputText = this.inputText.value || "";
      const totalLength = this.countCharacters(inputText + zodiac);

      if (totalLength >= this.maxLength && !allowedKeys.includes(e.key)) {
        this.triggerPulse();
        e.preventDefault();
      }
    });

    this.inputText.addEventListener("blur", () => {
      this.inputText.classList.remove("input-limit-reached");
    });

    this.selectZodiac.addEventListener("change", () => this.updateInputCounting());
  }

  updateInputCounting() {
    const zodiac = this.selectZodiac.value || "";
    const inputText = this.inputText.value || "";
    const totalLength = this.countCharacters(inputText + zodiac);
    const remaining = this.maxLength - totalLength;
    this.inputCounting.textContent = `CARACTERE RAMASE:  ${Math.max(remaining, 0)}`;

    if (totalLength > this.maxLength) {
      this.inputText.classList.add("input-limit-reached");
    } else {
      this.inputText.classList.remove("input-limit-reached");
      this.drawTextWithZodiac();
    }
  }

  triggerPulse() {
    this.inputText.classList.remove("input-limit-reached");
    void this.inputText.offsetWidth;
    this.inputText.classList.add("input-limit-reached");
  }

  setupCollapse() {
    const toggles = document.querySelectorAll(".customization-collapse-toggle");
    toggles.forEach(toggle => {
      const content = toggle.nextElementSibling;
      if (!content) return;
      toggle.addEventListener("click", () => {
        toggle.classList.toggle("collapsed");
        content.classList.toggle("collapsed");

        const isExpanded = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", String(!isExpanded));
      });
    });
  }

drawTextWithZodiac() {
  const width = this.canvas.clientWidth || 600;
  const height = this.canvas.clientHeight || 600;
  this.canvas.width = width;
  this.canvas.height = height;

  this.ctx.clearRect(0, 0, width, height);

  const text = this.inputText.value.slice(0, this.maxLength).trim();
  const zodiac = this.selectZodiac.value;
  const zodiacName = this.selectZodiac.selectedOptions[0]?.dataset.zodiacName;

  if (!text && !zodiacName) return;

  const posYPercent = parseFloat(this.customizationBlock?.dataset.positioncanvay) || 50;
  const posXPercent = parseFloat(this.customizationBlock?.dataset.positioncanvasx) || 50;
  const y = height * (posYPercent / 100);

  this.ctx.font = `${this.fontSize}px "Times New Roman", serif`;
  this.ctx.textAlign = "left";
  this.ctx.fillStyle = this.matchedHexColor;
  // this.ctx.shadowColor = "#000";
  // this.ctx.shadowBlur = 6;

  const metrics = this.ctx.measureText(text);
  const textHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
  const textWidth = metrics.width;
  const padding = 10;

  if (!zodiacName || !window.zodiacSVGs[zodiacName]) {
    const x = width * (posXPercent / 100) - textWidth / 2;
    this.ctx.fillText(text, x, y);
    return;
  }

  const svgTextOriginal = window.zodiacSVGs[zodiacName];
  const coloredSvgText = svgTextOriginal.replace(/currentColor/g, this.matchedHexColor);

  const img = new Image();
  const svgBlob = new Blob([coloredSvgText], { type: "image/svg+xml;charset=utf-8" });
  const url = URL.createObjectURL(svgBlob);

img.onload = () => {
  const firstChar = text.trim().charAt(0);
  const isUppercase = /^[A-Z]$/.test(firstChar);
  const textHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;

  const svgTargetHeight = metrics.actualBoundingBoxAscent;
  const scale = svgTargetHeight / img.naturalHeight;
  const imgWidth = img.naturalWidth * scale;
  const imgHeight = svgTargetHeight;

  const spacing = this.ctx.measureText("").width;
  const totalWidth = textWidth + spacing + imgWidth;
  const x = width * (posXPercent / 100) - totalWidth / 2;
  const drawY = y - (isUppercase ? metrics.actualBoundingBoxAscent : imgHeight);


  // console.log("Text metrics:", {
  //   text,
  //   textWidth,
  //   textHeight,
  //   ascent: metrics.actualBoundingBoxAscent,
  //   descent: metrics.actualBoundingBoxDescent
  // });

  // console.log("SVG dimensions:", {
  //   naturalWidth: img.naturalWidth,
  //   naturalHeight: img.naturalHeight,
  //   scaledWidth: imgWidth,
  //   scaledHeight: imgHeight,
  //   basedOn: isUppercase ? "uppercase letter" : "fixed height"
  // });

  this.ctx.fillText(text, x, y);
  this.ctx.drawImage(img, x + textWidth + spacing, drawY, imgWidth, imgHeight);


  // this.ctx.strokeStyle = "red";
  // this.ctx.strokeRect(x, y - metrics.actualBoundingBoxAscent, textWidth, textHeight);


  // this.ctx.strokeStyle = "blue";
  // this.ctx.strokeRect(x + textWidth + spacing, drawY, imgWidth, imgHeight);

  URL.revokeObjectURL(url);
};



  img.src = url;
}





  handleVariantClick() {
    document.addEventListener("click", (e) => {
      const label = e.target.closest(".variant__button-label");
      if (!label) return;
      const inputId = label.getAttribute("for");
      if (inputId && inputId.includes("option-metalware")) {
        const inputEl = document.getElementById(inputId);
        if (inputEl) {
          const selectedValue = inputEl.value;
          const matched = this.colorsData.colors.find(c => c.name.toLowerCase() === selectedValue.toLowerCase());
          if (matched) {
            this.matchedHexColor = matched.hex;
          } else {
            this.matchedHexColor = "#00ccff";
          }
          this.drawTextWithZodiac();
          if (this.inputPlaceHolder && matched) {
            this.inputPlaceHolder.value = matched.name;
            this.inputPlaceHolder.setAttribute("value", matched.name);
          }
        }
      }
    });
  }

  attachCanvasToSlide(index) {
    if (!this.slider || !index) return;
    const target = this.slider.querySelector(`.product-main-slide[data-index="${index}"] .image-wrap`);
    if (target && !target.contains(this.previewWrapper)) {
      target.style.position = "relative";
      target.appendChild(this.previewWrapper);
      this.canvasAttached = true;
    }
    this.drawTextWithZodiac();
  }

  setupVariantImageListeners() {
    document.addEventListener('variantImageChangedCustomize', (e) => {
      const index = e.detail.imageIndex;
      this.attachCanvasToSlide(index);
    });

    document.addEventListener('variantImageDefaultCustomization', (e) => {
      if (!this.canvasAttached) {
        this.attachCanvasToSlide(e.detail.index);
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new ProductCustomization();
});

window.zodiacSVGs = {
  "aries": `<svg id="a" xmlns="http://www.w3.org/2000/svg"  fill="currentColor" viewBox="0 0 370.43 302.24"><defs><style></style></defs><path class="b" d="m349.17,43.31C321.34,6.5,271.75-9.11,228.48,5.35c-18.49,6.19-33.38,17.49-44.3,32.31-10.71-13.5-24.86-23.85-42.24-29.67-43.24-14.48-92.83,1.11-120.66,37.94C-5.72,81.69-2.13,115.44,5.61,137.45c8.52,24.18,27.77,47.65,42.07,51.24,11.33,2.78,22.91-4.03,25.78-15.42,2.49-9.89-2.41-19.95-11.23-24.25-3.6-3.13-16.25-16.9-19.11-35.93-2.16-14.37,1.81-27.93,12.09-41.54,16.72-22.1,47.51-31.86,73.23-23.28,22.92,7.7,35.54,28.4,35.54,58.27v174.46c0,11.76,9.5,21.24,21.25,21.24s21.25-9.48,21.25-21.24V103.94c0-29.89,12.62-50.58,35.53-58.28,25.77-8.59,56.53,1.17,73.23,23.27,10.29,13.61,14.23,27.21,12.07,41.53-2.87,19.06-15.51,32.83-19.09,35.93-8.83,4.32-13.74,14.36-11.25,24.26,2.87,11.4,14.4,18.3,25.8,15.42,14.3-3.6,33.53-27.07,42.07-51.24,7.73-22.04,11.32-55.8-15.67-91.51h0Z"/></svg>`,
  "taurus": `<svg id="a" xmlns="http://www.w3.org/2000/svg"  fill="currentColor" viewBox="0 0 302.29 317.75"><defs><style></style></defs><g id="b"><path class="c" d="m287.18,0h-3.78c-16.94.1-33.08,7.21-44.59,19.65l-60.46,89.93c-8.87-2.42-18.01-3.69-27.21-3.78-9.19.09-18.34,1.36-27.21,3.78L64.99,21.92l-1.51-2.27C51.98,7.21,35.83.1,18.89,0h-3.78C6.76,0,0,6.77,0,15.11s6.77,15.11,15.11,15.11h3.78c8.24-.09,16.15,3.19,21.92,9.07l55.17,82.37c-49.86,30.47-65.58,95.58-35.11,145.44,30.47,49.86,95.58,65.58,145.44,35.11,49.86-30.47,65.58-95.58,35.11-145.44-8.75-14.32-20.79-26.36-35.11-35.11l55.17-82.37c5.76-5.88,13.68-9.16,21.92-9.07h3.78c8.35,0,15.11-6.77,15.11-15.11S295.52,0,287.18,0h0Zm-60.45,211.6c0,41.74-33.83,75.57-75.57,75.57s-75.57-33.83-75.57-75.57,33.83-75.57,75.57-75.57,75.57,33.83,75.57,75.57h0Z"/></g></svg>`,
  "gemini": `<svg id="a" xmlns="http://www.w3.org/2000/svg"  fill="currentColor" viewBox="0 0 250.06 317.77"><defs><style></style></defs><path class="b" d="m181.14,237.31V82.06c22.09-4.92,39.4-13.46,51.51-25.73,16.78-16.99,17.45-34.51,17.41-37.85-.13-10-8.08-17.64-18.08-18-10.1-.28-18.49,7.73-19.27,17.68-.84,10.91-19.04,31.49-81.76,31.49S45.96,27.92,43.79,16.35C42.5,6.39,33.62-1.07,23.47.12,13.19,1.08,5.65,10.19,6.61,20.48c.21,2.08,4.79,40.14,59.67,57.73v159.42C5.2,254.17.29,295.13.08,297.31c-.94,9.97,6.21,18.5,16.14,19.84,9.9,1.34,19.22-5.76,20.99-15.61,2.07-11.57,22.97-33.41,87.18-33.41s80.91,20.58,81.76,30.75c-.13,10.31,8.14,18.79,18.46,18.89h.21c10.21,0,18.57-8.23,18.69-18.46.03-3.34-.62-20.87-17.41-37.85-10.86-11.02-25.99-19.02-44.95-24.13v-.02Zm-77.51-5.86V85.57c8.43.86,17.32,1.46,27.28,1.46,4.43,0,8.64-.2,12.85-.37v144.74c-6.22-.43-12.63-.7-19.38-.7-7.34,0-14.25.26-20.74.74h-.01Z"/></svg>`,
  "cancer": `<svg id="a" xmlns="http://www.w3.org/2000/svg"  fill="currentColor" viewBox="0 0 340.73 302.23"><defs><style></style></defs><path class="b" d="m297.65,191.06c-.93.83-75.05,66.19-158.08,64.38,10.05-13.11,16.29-29.34,16.29-47.15,0-42.96-34.95-77.9-77.93-77.9-42.97,0-77.93,34.94-77.93,77.92,0,38.33,27.83,70.08,64.31,76.54,26.83,12.24,53.58,17.38,79.21,17.38,98.79,0,180.84-72.78,185.17-76.7,9.52-8.59,10.24-23.22,1.7-32.71-8.59-9.55-23.23-10.3-32.76-1.76h.02Zm-219.71,48.79c-17.4,0-31.54-14.12-31.54-31.55s14.14-31.53,31.54-31.53,31.54,14.14,31.54,31.53-14.14,31.55-31.54,31.55h0Z"/><path class="b" d="m43.08,111.16c.93-.82,75.05-66.17,158.09-64.36-10.04,13.11-16.3,29.33-16.3,47.12,0,42.97,34.95,77.92,77.94,77.92s77.92-34.94,77.92-77.92c0-38.31-27.84-70.06-64.31-76.53C249.58,5.11,222.84,0,197.21,0,98.42,0,16.37,72.78,12.04,76.7c-9.53,8.59-10.24,23.22-1.7,32.7,8.6,9.57,23.24,10.32,32.76,1.76h-.02Zm219.72-48.78c17.39,0,31.53,14.13,31.53,31.54s-14.14,31.54-31.53,31.54-31.55-14.13-31.55-31.54,14.14-31.54,31.55-31.54Z"/></svg>`,
  "leo": `<svg id="a" xmlns="http://www.w3.org/2000/svg"  fill="currentColor" viewBox="0 0 266.11 296.43"><defs><style></style></defs><path class="b" d="m196.37,296.43c-10.25,0-19.28-2.21-26.14-6.4-16.69-13.8-26.62-30.01-28.71-46.88-2.1-16.94,3.68-34.75,16.71-51.51,19.21-24.71,34.4-49.73,43.94-72.35,9.89-23.47,13.2-43.36,9.56-57.52-1.91-7.5-6.49-18.35-24.08-25.95l-.1-.04c-12.11-4.92-23.07-7.41-32.6-7.41s-17.1,2.26-23.69,6.71c-27.66,18.86-29.53,71.77-29.65,77.74l-.07,3.64,3,2.07c18.17,12.54,29.02,33.1,29.02,55.01,0,36.82-29.95,66.78-66.77,66.78S0,210.36,0,173.54s29.74-66.55,66.34-66.79c.28.03.56.05.83.05h6.21l.53-6.18c2.07-24.04,10.19-67.54,41.32-88.83C126.67,3.96,139.9,0,154.56,0c13.33,0,28.14,3.26,44.02,9.68,21.4,9.29,35.45,24.88,40.62,45.07,13.72,53.57-36.4,125.72-58.58,154.26-7.32,9.45-10.08,25.48-6.71,38.99,2.56,10.27,8.3,17.87,16.16,21.39,2.52,1.13,5.23,1.7,8.07,1.7,14.15,0,27.41-14.25,32.45-20.37,7.01-8.52,7.53-11.99,7.05-14.48-.77-3.76-.05-7.55,2.04-10.71,2.08-3.15,5.26-5.3,8.96-6.05.95-.2,1.91-.3,2.86-.3,6.67,0,12.49,4.77,13.84,11.34,4.99,24.44-15.12,46.26-33.86,57.53-6.69,4.04-20.51,8.38-35.08,8.38h-.03ZM66.76,135.04c-21.21,0-38.47,17.27-38.47,38.49s17.26,38.46,38.47,38.46,38.46-17.25,38.47-38.46c0-21.23-17.26-38.5-38.47-38.5h0Z"/></svg>`,
  "virgo": `<svg id="a" xmlns="http://www.w3.org/2000/svg"  fill="currentColor" viewBox="0 0 362.61 317.41"><defs><style></style></defs><path class="b" d="m361.27,170.1c5.64-33.76-6.78-65.5-33.21-84.93-13.88-10.2-29.81-15.46-44.07-15.34v-17.03C283.99,7.62,246.67,0,223.13,0,207.33,0,192.67,5.94,181.77,16.76c-.02.02-.03.05-.06.07C170.14,5.79,154.81,0,139.91,0c-15.75,0-30.44,5.94-41.34,16.76-.09.07-.16.2-.24.28-11.16-9.31-25.09-14.37-38.73-14.37-15.77,0-30.46,5.94-41.36,16.76C9.92,27.69,0,42.67,0,67.01c0,11.09,8.97,20.07,20.08,20.07s20.08-8.97,20.08-20.07c0-22.43,14.87-24.17,19.43-24.17,9.55,0,20.7,6.32,20.7,24.17v169.87c0,11.09,8.99,20.07,20.08,20.07s20.08-8.99,20.08-20.07V64.31c0-22.43,17.5-24.13,22.3-24.13s21.27,1.28,21.27,27.31c0,32.53-.51,169.37-.51,169.37,0,11.09,8.97,20.07,20.08,20.07s20.08-8.99,20.08-20.07V64.31c0-22.43,14.87-24.16,19.43-24.16,9.55,0,20.71,6.31,20.71,24.16,0,0,.58,183.27.56,195.21-16.32,9.56-32.16,15.82-44.12,18.09-10.9,2.06-18.07,12.54-16.02,23.46,1.82,9.63,10.24,16.34,19.72,16.34,1.21,0,2.5-.14,3.74-.34,16.11-3.07,38.55-11.84,61.4-25.8,21.49,11,50.84,16.31,65.71,18.44,10.83,1.46,21.16-6.09,22.71-17.04,1.58-11-6.04-21.16-17.04-22.73-11.42-1.65-23.31-4.25-33.44-7.11,26.27-24.06,47.99-55.31,54.25-92.72h0Zm-76.63,58.72c.02-8.85.06-18.65.1-28.89.11-32.49.24-68.79.24-90.16,4.5.23,12.99,2.48,21.27,9.28,7.5,6.15,19.47,20.11,15.4,44.4-4.15,24.96-18.72,47.22-37.01,65.36h0Z"/></svg>`,
  "libra": `<svg id="a" xmlns="http://www.w3.org/2000/svg"  fill="currentColor" viewBox="0 0 517.01 302.23"><defs><style></style></defs><path class="b" d="m23.85,199.44c-13.15,0-23.85-10.71-23.85-23.87s10.7-23.84,23.85-23.84h91.1l.22-5.29c2.01-47.69,15.56-84.53,40.27-109.5C179.67,12.42,213.61,0,256.3,0c78.07,0,113.71,41.82,129.85,76.9,9.14,19.94,14.76,43.41,16.72,69.75l.38,5.11h89.81c13.15,0,23.85,10.69,23.85,23.84s-10.7,23.8-23.85,23.8h-113.14c-13.14,0-23.84-10.68-23.84-23.8.02-16.19.05-49.89-13.21-78.76-15.46-33.52-42.96-49.12-86.55-49.12-29.88,0-51.77,7.44-66.93,22.76-27.52,27.85-26.98,76.17-26.73,99.39l.03,5.78c0,13.1-10.7,23.79-23.85,23.79H23.85Z"/><path class="b" d="m23.85,302.23c-13.15,0-23.85-10.7-23.85-23.85s10.7-23.82,23.85-23.82h469.32c13.14,0,23.84,10.69,23.84,23.82s-10.69,23.85-23.84,23.85H23.85Z"/></svg>`,
  "scorpio": `<svg id="a" xmlns="http://www.w3.org/2000/svg"  fill="currentColor" viewBox="0 0 421.28 317.41"><defs><style></style></defs><path class="b" d="m414.18,234.43l-59.34-42.52c-5.25-3.77-12.13-4.29-17.83-1.37-5.73,2.94-9.31,8.82-9.31,15.26v26.12c-11.36-2.73-26.47-8.55-26.47-17.55V55.99c0-38.24-39.58-55.99-64.55-55.99-16.74,0-32.31,6.31-43.89,17.79,0,0-.04.04-.07.05C180.46,6.13,164.19,0,148.39,0c-16.71,0-32.29,6.31-43.85,17.79-.09.07-.17.2-.26.28-11.82-9.88-26.6-15.22-41.08-15.22-16.72,0-32.3,6.31-43.86,17.79C10.52,29.38,0,45.26,0,71.07c0,11.78,9.53,21.29,21.3,21.29s21.29-9.53,21.29-21.29c0-23.78,15.77-25.61,20.61-25.61,10.14,0,21.98,6.7,21.98,25.61v180.19c0,11.78,9.52,21.29,21.29,21.29s21.29-9.55,21.29-21.29V68.23c0-23.78,15.79-25.62,20.62-25.62,28.86,0,25.06,27.72,25.06,36v172.65c0,11.78,9.53,21.29,21.29,21.29s21.3-9.55,21.3-21.29V68.23c0-23.78,15.75-25.62,20.61-25.62,10.14,0,21.96,6.72,21.96,25.62v146.21c0,40.58,41.33,56.9,69.02,60.86v24.93c0,6.74,3.96,12.84,10.09,15.64,2.29,1.03,4.66,1.54,7.07,1.54,4.1,0,8.1-1.45,11.28-4.23l59.34-51.84c3.98-3.45,6.14-8.51,5.86-13.76-.2-5.31-2.83-10.11-7.1-13.15h.02Z"/></svg>`,
  "sagittarius": `<svg id="a" xmlns="http://www.w3.org/2000/svg"  fill="currentColor" viewBox="0 0 296.12 295.29"><defs><style></style></defs><path class="b" d="m16.34,295.27c-4.38,0-8.49-1.7-11.56-4.8-3.09-3.1-4.78-7.21-4.78-11.58s1.71-8.46,4.8-11.54l109.12-108.79-36.86-38.22c-3.03-3.15-4.65-7.29-4.57-11.65.08-4.36,1.86-8.43,5.01-11.46,3.06-2.96,7.09-4.58,11.34-4.58,4.49,0,8.67,1.77,11.78,5l36.47,37.85,103.12-102.8h-66.15c-9.02,0-16.35-7.34-16.35-16.35S165.05,0,174.06,0h105.7c2.11,0,4.2.43,6.24,1.28,1.91.79,3.61,1.89,5.05,3.27l.11.17.23.23c1.47,1.51,2.63,3.25,3.43,5.19.66,1.58,1.03,3.47,1.12,5.61v.12c.04.37.11.69.18.93v103.62c0,9.02-7.33,16.36-16.34,16.36s-16.38-7.34-16.38-16.36V55.77l-103.62,103.29,41.74,43.32c6.25,6.5,6.05,16.87-.44,23.12-3.03,2.96-7.05,4.58-11.34,4.58s-8.67-1.78-11.78-5.01l-41.37-42.93-108.71,108.38c-3.09,3.08-7.2,4.77-11.55,4.77v-.02Z"/></svg>`,
  "capricorn": `<svg id="a" xmlns="http://www.w3.org/2000/svg"  fill="currentColor" viewBox="0 0 445.89 359.35"><defs><style></style></defs><path class="b" d="m352.03,101.27c-30.84,0-58.03,16.27-75.17,40.99-8.58-19.83-17-46.84-17-76.9,0-36.93-27.9-61.75-69.42-61.75-21.28,0-43.3,6.91-58.43,20.12C113.47,8.53,86.61,0,64.77,0c-17.36,0-32.48,5.04-43.7,14.57C11.45,22.74,0,38.17,0,65.39c0,12.25,9.25,22.15,20.65,22.15s20.65-9.9,20.65-22.15c0-10.8,2.83-18.4,16.65-20.56,24.55-3.95,52.63,13.21,54.75,20.56v181.03c0,12.23,9.25,22.15,20.65,22.15s20.64-9.92,20.64-22.15V65.39c0-7.81,16.81-17.42,36.43-17.42,9.04,0,17.2,2.12,22.35,5.76,4.1,2.92,5.76,6.33,5.76,11.67,0,64.09,29.19,115.24,40.04,132.03-.08,1.56-.43,3.05-.43,4.64,0,15.81,3.71,30.51,9.71,43.82-12.65,20.65-48.12,67.69-109.54,69.11-11.4.28-20.46,10.36-20.22,22.66.25,12.08,9.45,21.69,20.65,21.69h.43c70.44-1.6,114.48-47.87,135.7-77.85,15.9,13.19,35.55,21.39,57.13,21.39,51.8,0,93.89-45.18,93.89-100.74s-42.07-100.86-93.87-100.86v-.02Zm0,157.25c-28.98,0-52.58-25.32-52.58-56.44s23.59-56.43,52.58-56.43,52.6,25.32,52.6,56.43-23.59,56.44-52.6,56.44h0Z"/></svg>`,
  "aquarius": `<svg id="a" xmlns="http://www.w3.org/2000/svg"  fill="currentColor" viewBox="0 0 515.83 302.24"><path d="m310.54,165.78c44.12-5.94,69.56,67.13,90.34,70.56,27.01,4.45,52.59-59.73,96.26-51,9.48,1.9,18.81,11.91,18.68,21.42-.16,12.15-81.43,90.11-96.57,93.59-45.44,10.44-87.98-75.44-106.63-75.49-8.15-.02-62.17,67.35-85.48,70.93-52.22,8.01-73.8-64.52-96.39-64.91-22.04-.39-69.55,65.2-88.77,70.14-19.95,5.12-44.96-6.11-38.33-29.8,8.77-31.35,61.2-81.17,91.61-93.12,83.53-32.82,84.31,61.23,126.48,55.59,19.99-2.68,61.52-64.22,88.79-67.89v-.02Z"/><path d="m307.95.34c44.12-5.94,69.56,67.13,90.34,70.56,27.01,4.45,52.59-59.73,96.26-51,9.48,1.9,18.81,11.91,18.68,21.42-.16,12.15-81.43,90.11-96.57,93.59-45.44,10.44-87.98-75.44-106.63-75.49-8.15-.02-62.17,67.35-85.48,70.93-52.22,8.01-73.8-64.52-96.39-64.91-22.04-.39-69.55,65.2-88.77,70.14S-5.57,129.47,1.06,105.78C9.83,74.43,62.26,24.61,92.67,12.66c83.53-32.82,84.31,61.23,126.48,55.59,19.99-2.68,61.52-64.22,88.79-67.89v-.02Z"/></svg>`,
  "pisces": `  <svg id="a" xmlns="http://www.w3.org/2000/svg"  fill="currentColor" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 238 302.24"><defs><style>.c{clip-path:url(#b);}.d{fill:none;}</style><clipPath id="b"><rect class="d" width="238" height="302.23"/></clipPath></defs><g class="c"><path class="e" d="m60.45,169.38c-15.55-.02-30.77.12-46.28-.04-8.79-.09-15.22-8.57-13.82-17.24,1.51-10.82,12.22-14.04,22.03-13.74,12.45-.09,24.91-.04,37.96-.04-2.88-38.56-17.78-77.02-44.16-105.52-4.73-4.83-6.9-10.32-5.36-17.08,1.23-5.4,4.65-9.02,9.67-10.7,5.9-1.97,11.78-1.13,16.2,3.48,9.07,9.47,17.2,19.71,23.95,31.03,18.54,29.56,25.77,62.59,31.22,96.81,14.7-.39,30.35-.8,46.09-1.21-.3-53.78,34.48-97.24,73.01-131.18,13.44-11.76,35.42,5.11,23.07,21.01-3.97,4.66-8.43,8.97-13.04,13.01-28.06,25.21-49.88,58.4-51.72,96.97,14.5,0,28.81-.05,43.29.05,10.49.05,20.47-.08,24.47,11.9,3.77,10.89-5.94,20.95-16.73,20.46-16.05-.23-31.71-.58-47.81-.67,8.08,33.6,24.23,64.08,41.47,93.71,3.98,6.77,9.97,12.33,14.52,18.81,10.99,15.2-10.08,30.84-22.54,17.42-33.84-34.55-53.81-80.78-64.76-127.36-.46-1.86-1.02-2.66-3.02-2.61-12.89.3-25.79.47-38.68.76-2.97.27-7.92-.44-8.77,3.27-2.26,44.52-14.81,91.64-47.22,123.84-4.83,4.57-10.05,8.04-17.2,7.7-10.13-.49-16.94-10.54-12.76-19.8,1.26-2.78,3.85-5.3,6.43-7.08,6.48-4.47,10.66-10.82,14.76-17.18,17.91-26.27,22.87-57.73,25.73-88.77h0Z"/></g></svg>`
};
